import dynamic from 'next/dynamic'
import Space from '@components/display/Space'

const DynamicFlag = dynamic(
    () => import('@components/display/flag/Flag'),
    {
        ssr: false,
        loading: () => <Space />
    }
)

const Flag = (props) => <DynamicFlag {...props} />

export default Flag